import { get } from './http'
export const indexData = () => get('/yr/index/getData',{});
export const productType = () => get('/yr/product/typeList',{});
export const productData = () => get('/yr/product/list',{});
export const productInfo = p => get('/yr/product/getInfo',p);
export const solutionData = () => get('/yr/solution/list',{});
export const solutionInfo = p => get('/yr/solution/getInfo',p);
export const aboutData = () => get('/yr/about/list',{});